import useReveal from "../hooks/useReveal";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Ecosystem from "../components/landing/Ecosystem";
import Problem from "../components/landing/Problem";
import Pillars from "../components/landing/Pillars";
import Services from "../components/landing/Services";
import Innovation from "../components/landing/Innovation";
import Process from "../components/landing/Process";
import Differentiators from "../components/landing/Differentiators";
import Stats from "../components/landing/Stats";
import CTA from "../components/landing/CTA";
import Footer from "../components/landing/Footer";

export default function PixelgrokLanding() {
    useReveal();
    return (
        <main
            data-testid="pixelgrok-landing"
            className="relative bg-[#050505] text-white grain-overlay min-h-screen"
        >
            <Nav />
            <Hero />
            <Marquee />
            <Ecosystem />
            <Problem />
            <Pillars />
            <Services />
            <Innovation />
            <Process />
            <Differentiators />
            <Stats />
            <CTA />
            <Footer />
        </main>
    );
}
